<div class="flex-direction-column gap-15">
  <div class="card-separacao flex align-center">
    <span class="font-10 weight-600">Meus Canais</span>
  </div>
  <div>
    @for (canal of canais; track canal.id) {
      <span>{{ canal.nome ?? '--' }}</span>
    }
  </div>
</div>
